import day from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

// Plugin configuration (https://day.js.org/docs/en/plugin/plugin)
// To enable additional day.js plugin functionality, extend here.
// This ensures any extensions are applied consistently across the various
// frontend projects

day.extend(utc);
day.extend(relativeTime);

export const dayjs = day;
